import DineInBannerView from './dine-in-banner-view'

export default DineInBannerView
